import React, { Component } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Table, Button, } from 'semantic-ui-react'
import { pythonApiIp, } from '../../../../config/constants'
import * as UiConsts from '../../../../config/UiConstants';

class ViewLargeProjectDocs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showDocs: false,
            documents: []
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");
        if (this.props.projectId) {
            
        } else {
            alert("no project Id sent");
        }
    }

    showDocs = () => {
        console.log("doc41 ++++ showDocs")
        console.log("doc42 showDocs:"+this.state.showDocs);
        if (this.state.showDocs) {
            this.setState({ showDocs: false });
        } else if (!this.state.showDocs) {
            this.getProjectDocs();
            this.setState({ showDocs: true });
        }

    }

    getProjectDocs = () => {
        console.log("++++++++:getProjectDocs");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getDocumentList', {
            apiKey: "PrintB@da7",
            projectId: this.props.projectId
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. adding customer");
                    console.log("pltx2 documents:" + JSON.stringify(response.data, null, 3))
                    this.setState({
                        documents: response.data.documents,
                    })

                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                    this.setState({ loading: false })
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    render() {


        const rows = this.state.documents.length > 0
            ? this.state.documents.map((item) =>
                <Table.Row key={item.idlargeprojectdocuments}>
                    <Table.Cell> {item.idlargeprojectdocuments} </Table.Cell>
                    <Table.Cell> {item.documenttype} </Table.Cell>
                    <Table.Cell> <a href={item.documentlink} target="_blank">VIEW</a> </Table.Cell>
                    {/* <Table.Cell> {item.addedby} </Table.Cell> */}
                    <Table.Cell> {item.senton} </Table.Cell>
                    <Table.Cell> {item.vatincluded} </Table.Cell>
                    <Table.Cell> {item.sentto} </Table.Cell>
                   
                </Table.Row>)
            : ''

        const wholeUi = this.state.showDocs ?
            <div>
                <h2>PROJECT DOCS</h2>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>id</Table.HeaderCell>
                            <Table.HeaderCell>documenttype</Table.HeaderCell>
                            <Table.HeaderCell>Download</Table.HeaderCell>
                            <Table.HeaderCell>senton</Table.HeaderCell>
                            <Table.HeaderCell>Vac Incl</Table.HeaderCell>
                            <Table.HeaderCell>Sent to</Table.HeaderCell>
    
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>
            </div>
            : ''

        return (  this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                <Button fluid color='olive' onClick={this.showDocs}>Show Docs </Button>
                {wholeUi}

            </div>
        );
    }
}

export default ViewLargeProjectDocs;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeProjectDocs.js